export const AudioFX = [
    {
        "title": "Space Drone FX",
        "url": "../sounds/dronefx.mp3"
    },
    {
        "title": "Space Drone FX",
        "url": "../sounds/dronefx2.mp3"
    },
    {
        "title": "Space Drone FX",
        "url": "../sounds/dronefx2.mp3"
    },
    {
        "title": "Space Drone FX",
        "url": "../sounds/dronefx2.mp3"
    }

]

export default AudioFX